import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect, useState } from 'react';
import RowRadioList from '../RowRadioList';
import RowStepper from '../RowStepper';
import RowInput from '../RowInput';
import './index.less';
export default function ChooseEnumBtn(props) {
  const {
    attrs,
    formKey,
    label
  } = props;
  const {
    sumInsuredType,
    premiumCalculateType,
    isProduct,
    product,
    isLiability,
    liability,
    dataSource = []
  } = attrs;
  const isAddition = product.productType === 'addition';
  const title = /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, isAddition ? /*#__PURE__*/React.createElement("span", {
    className: "addition"
  }, "\u9644") : null, label);
  const [newDataSource, setNewDataSource] = useState(dataSource);
  const [sumInsuredFormatType, setSumInsuredFormatType] = useState('元'); // 单位

  const [sumInsuredValueStr, setSumInsuredValueStr] = useState(''); // 范围

  const [stepSumInsuredValue, setStepSumInsuredValue] = useState({}); // 步进值范围

  const [inputSumInsuredValue, setInputSumInsuredValue] = useState({}); // 范围输入大小

  const [copiesSumInsuredValue, setCopiesSumInsuredValue] = useState({}); // 份额固定值
  // const cloneDataSource = _.cloneDeep(dataSource);

  const handleDataSource = () => {
    let insuredFormatType;
    let rangeStr;
    let stepValueRange = {};
    let inputValueRange = {};
    let copiesValueRange = {};

    if (isProduct) {
      insuredFormatType = premiumCalculateType === 'byPremium' ? product === null || product === void 0 ? void 0 : product.premiumFormatType : product === null || product === void 0 ? void 0 : product.sumInsuredFormatType;
      rangeStr = premiumCalculateType === 'byPremium' ? product === null || product === void 0 ? void 0 : product.premiumValueStr : (product === null || product === void 0 ? void 0 : product.sumInsuredValueStr) || '';
      stepValueRange = premiumCalculateType === 'byPremium' ? product === null || product === void 0 ? void 0 : product.stepPremiumValue : product === null || product === void 0 ? void 0 : product.stepSumInsuredValue;
      inputValueRange = premiumCalculateType === 'byPremium' ? product === null || product === void 0 ? void 0 : product.inputPremiumValue : product === null || product === void 0 ? void 0 : product.inputSumInsuredValue;
      copiesValueRange = premiumCalculateType === 'byPremium' ? product === null || product === void 0 ? void 0 : product.copiesPremiumValue : product === null || product === void 0 ? void 0 : product.copiesSumInsuredValue;
    } else {
      insuredFormatType = premiumCalculateType === 'byPremium' ? liability === null || liability === void 0 ? void 0 : liability.premiumFormatType : liability === null || liability === void 0 ? void 0 : liability.sumInsuredFormatType;
      rangeStr = premiumCalculateType === 'byPremium' ? liability === null || liability === void 0 ? void 0 : liability.premiumValueStr : (liability === null || liability === void 0 ? void 0 : liability.sumInsuredValueStr) || '';
      stepValueRange = premiumCalculateType === 'byPremium' ? liability === null || liability === void 0 ? void 0 : liability.stepPremiumValue : liability === null || liability === void 0 ? void 0 : liability.stepSumInsuredValue;
      inputValueRange = premiumCalculateType === 'byPremium' ? liability === null || liability === void 0 ? void 0 : liability.inputPremiumValue : liability === null || liability === void 0 ? void 0 : liability.inputSumInsuredValue;
      copiesValueRange = premiumCalculateType === 'byPremium' ? liability === null || liability === void 0 ? void 0 : liability.copiesPremiumValue : liability === null || liability === void 0 ? void 0 : liability.copiesSumInsuredValue;
    }

    const unitText = insuredFormatType === 'wanYuan' ? '万元' : '元'; // setFormValue(`chooseEnumBtnUnit.${_name}`, insuredFormatType);

    setSumInsuredValueStr(rangeStr);
    setSumInsuredFormatType(unitText);

    if (sumInsuredType === 'enum') {
      // setNewDataSource(cloneDataSource);
      setNewDataSource(dataSource);
    } else if (sumInsuredType === 'step') {
      setStepSumInsuredValue(stepValueRange);
    } else if (sumInsuredType === 'range') {
      setInputSumInsuredValue(inputValueRange);
    } else if (sumInsuredType === 'copies') {
      setCopiesSumInsuredValue(copiesValueRange);
    }
  };

  const enumType = () => {
    return /*#__PURE__*/React.createElement(RowRadioList, _extends({}, props, {
      label: title
    }));
  };

  const step = () => {
    return /*#__PURE__*/React.createElement(RowStepper, _extends({}, props, {
      label: title
    }, stepSumInsuredValue));
  };

  const range = () => {
    const {
      maxValue,
      minValue
    } = inputSumInsuredValue || {};

    const validateRage = (relue, value, callback) => {
      if (value >= minValue && value <= maxValue) {
        callback();
      } else {
        callback(new Error('请输入正确的范围值'));
      }
    };

    return /*#__PURE__*/React.createElement(RowInput, _extends({
      validateTrigger: "onBlur",
      defaultValue: minValue,
      inputType: "number",
      rules: [{
        validator: validateRage
      }]
    }, props, {
      label: title
    }, inputSumInsuredValue));
  };

  const copies = () => {
    return /*#__PURE__*/React.createElement(RowInput, _extends({
      inputType: "number"
    }, props, {
      label: title
    }, copiesSumInsuredValue));
  }; //  enum：枚举 step：步进 range：范围 copies：份数


  const renderByType = type => {
    const Map = {
      enum: enumType,
      step,
      range,
      copies
    };
    return Map[type] && Map[type]();
  };

  useEffect(() => {
    handleDataSource();
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "form-item-box"
  }, renderByType(sumInsuredType));
}